import React from "react";
import { TrackingSettingsPanel } from "./TrackingSettingsPanel.jsx";

// The stateful shell around TrackingSettingsPanel. It owns nothing but WHICH ROW
// IS OPEN, and exists so the panel itself can stay a pure function of its props
// (see `openSection` there for why that matters to the tests).
//
// ONE ROW OPEN AT A TIME. Two open sliders on a ~330px panel puts the second
// one's tick labels off the fold, and fitting without scrolling is the reason the
// rows collapse at all. `null` = all closed, the state the page opens in, so a
// reader sees the summary of what the forecast is set to before any control.
//
// State lives HERE rather than in App: it is presentational, scoped to this panel,
// and App.jsx is explicitly not to re-grow with this kind of thing.
export function TrackingSettings(props) {
  const [openSection, setOpenSection] = React.useState(null);
  return (
    <TrackingSettingsPanel
      {...props}
      openSection={openSection}
      onToggleSection={(key) => setOpenSection((cur) => (cur === key ? null : key))}
    />
  );
}
